let pending: Promise<string | null> | null = null;

/** Share the exchange across React StrictMode remounts without persisting credentials. */
export function bootstrapSuiteSso(
  url: URL,
  clean: (url: string) => void,
  signIn: (token: string) => Promise<unknown>,
  signOut: () => Promise<unknown>,
): Promise<string | null> {
  if (pending) return pending;
  const token = url.searchParams.get('customToken');
  const legacy = url.searchParams.has('token') || url.searchParams.has('sso_token');
  if (!token && !legacy) return Promise.resolve(null);
  for (const key of ['customToken', 'token', 'sso_token']) url.searchParams.delete(key);
  clean(`${url.pathname}${url.search}${url.hash}`);
  const exchange = (async () => {
    try {
      if (!token) throw new Error('Unsupported sign-in link');
      await signIn(token);
      return null;
    } catch {
      try { await signOut(); } catch { /* The failed exchange never grants access. */ }
      return 'Single sign-on failed. Launch EF-Link again from the portal or sign in.';
    }
  })();
  pending = exchange;
  void exchange.finally(() => { if (pending === exchange) pending = null; });
  return exchange;
}
